function getRadUIVersion() {
  return window.innerWidth <= 760 ? 'ui:rad:mobile' : 'ui:rad:pc';
}
export const determineFlag = (optimizelyExperiment) => {
  if (!optimizelyExperiment?.isEnabled) {
    return null;
  }
  return optimizelyExperiment?.variationKey === 'vehicle_chooser_on' ? 'vehicle-selector:1' : 'vehicle-selector:0';
};

export function tagLandingPageView(specialEvent, countryCode, languageCode) {
  window.digitaldata = {
    page: {
      client: countryCode === 'USA' ? 'fmcc-usa': 'fmcc-can',
      hierarchy: 'financing:ovf:prequal',
      pageName: specialEvent ? 'flmc:ovf:prequal truck month' : 'flmc:ovf:prequal',
      pageNameNoVehicle: specialEvent ? 'flmc:ovf:prequal truck month' : 'flmc:ovf:prequal',
      radUIVersion: getRadUIVersion(),
      site: window.location?.href?.split('?')[0],
      siteSection: 'ovf',
      userlanguage: languageCode === 'FR' ? 'fre': 'eng',
      navLink: document?.referrer ? document?.referrer?.split('?')[0] : window.location.href
    }
  };
  window._satellite?.track('global-load');
}

export function tagProcessingPageView(customerData) {
  window.digitaldata = {
    page: {
      client: customerData.countryCode.value === 'USA' ? 'fmcc-usa' : 'fmcc-can',
      hierarchy: 'financing:ovf:prequal',
      pageName: customerData.specialEvent.value ? 'flmc:ovf:prequal truck month:app:5 processing' : 'flmc:ovf:prequal:app:5 processing',
      pageNameNoVehicle: customerData.specialEvent.value
        ? 'flmc:ovf:prequal truck month:app:5 processing'
        : 'flmc:ovf:prequal:app:5 processing',
      optimizely: determineFlag(customerData.optimizelyExperimentData),
      radUIVersion: getRadUIVersion(),
      site: window.location?.href?.split('?')[0],
      siteSection: 'ovf',
      userlanguage: customerData.languageCode === 'FR' ? 'fre': 'eng',
      customerID: customerData.uuid
    }
  };
  window._satellite?.track('global-load');
}

export function tagPrequalifiedResultPage(offerId, customerData) {
  window.digitaldata = {
    page: {
      client: customerData.countryCode.value === 'USA' ? 'fmcc-usa' : 'fmcc-can',
      hierarchy: 'financing:ovf:prequal',
      pageName: customerData.specialEvent.value ? 'flmc:ovf:prequal truck month:app:6 result' : 'flmc:ovf:prequal:app:6 result',
      pageNameNoVehicle: customerData.specialEvent.value ? 'flmc:ovf:prequal truck month:app:6 result' : 'flmc:ovf:prequal:app:6 result',
      radUIVersion: getRadUIVersion(),
      site: window.location?.href?.split('?')[0],
      siteSection: 'ovf',
      userlanguage: customerData.languageCode === 'FR' ? 'fre': 'eng',
      tool: 'prequal:complete',
      toolDescriptor: 'prequal:complete:qualified',
      customerID: customerData.uuid
    },
    finance: {
      leadOfferingID: offerId
    }
  };
  window._satellite?.track('ford-credit-ovf-decision');
}

export function tagPrequalifiedResultPagePPQ(offerId, customerData, showSpecialOffer = false) {
  window.digitaldata = {
    page: {
      client: customerData.countryCode.value === 'USA' ? 'fmcc-usa' : 'fmcc-can',
      hierarchy: 'financing:ovf:prequal',
      pageName: 'flmc:ovf:prequal:app:6 result',
      pageNameNoVehicle: 'flmc:ovf:prequal:app:6 result',
      optimizely: determineFlag(customerData.optimizelyExperimentData),
      radUIVersion: getRadUIVersion(),
      site: window.location?.href?.split('?')[0],
      siteSection: 'ovf',
      userlanguage: customerData.languageCode === 'FR' ? 'fre': 'eng',
      tool: 'prequal:complete',
      toolDescriptor: 'prequal:complete:qualified',
      customerID: customerData.uuid,
      formInput: `show special offer:${!!showSpecialOffer}`
    },
    finance: {
      leadOfferingID: offerId
    }
  };
  window._satellite?.track('ford-credit-ovf-decision');
}

export function tagUnsuccessfulPrequalifiedResultView(offerId, customerData) {
  window.digitaldata = {
    page: {
      client: customerData.countryCode.value === 'USA' ? 'fmcc-usa' : 'fmcc-can',
      hierarchy: 'financing:ovf:prequal',
      pageName: customerData.specialEvent.value ? 'flmc:ovf:prequal truck month:app:6 result' : 'flmc:ovf:prequal:app:6 result',
      pageNameNoVehicle: customerData.specialEvent.value ? 'flmc:ovf:prequal truck month:app:6 result' : 'flmc:ovf:prequal:app:6 result',
      radUIVersion: getRadUIVersion(),
      site: window.location?.href?.split('?')[0],
      siteSection: 'ovf',
      userlanguage: customerData.languageCode === 'FR' ? 'fre': 'eng',
      tool: 'prequal:complete',
      toolDescriptor: 'prequal:complete:not qualified',
      customerID: customerData.uuid
    },
    finance: {
      leadOfferingID: offerId
    }
  };
  window._satellite?.track('ford-credit-ovf-decision');
}

export function tagCreditFreezePrequalifiedResultView(offerId, customerData) {
  window.digitaldata = {
    page: {
      client: customerData.countryCode.value === 'USA' ? 'fmcc-usa' : 'fmcc-can',
      hierarchy: 'financing:ovf:prequal',
      pageName: customerData.specialEvent.value ? 'flmc:ovf:prequal truck month:app:6 result' : 'flmc:ovf:prequal:app:6 result',
      pageNameNoVehicle: customerData.specialEvent.value ? 'flmc:ovf:prequal truck month:app:6 result' : 'flmc:ovf:prequal:app:6 result',
      radUIVersion: getRadUIVersion(),
      site: window.location?.href?.split('?')[0],
      siteSection: 'ovf',
      userlanguage: customerData.languageCode === 'FR' ? 'fre': 'eng',
      tool: 'prequal:complete',
      toolDescriptor: 'prequal:complete:credit freeze',
      customerID: customerData.uuid
    }
  };
  window._satellite?.track('ford-credit-ovf-decision');
}
export function tagDownloadPrequalifiedOffer() {
  window.digitaldata = {
    onclick: {
      linkName: 'flmc:ovf:prequal:result:content action',
      onclick: 'home:ovf:prequal:result:content:download prequalification offer'
    }
  };
  window._satellite?.track('ford-credit-ovf-onclick');
}

export function tagExploreVehicleOnlineClick() {
  window.digitaldata = {
    onclick: {
      linkName: 'flmc:ovf:prequal:result:content action',
      onclick: 'home:ovf:prequal:result:content:explore vehicle online'
    }
  };
  window._satellite?.track('ford-credit-ovf-onclick');
}

export function tagConnectWithADealerClick(specialEvent) {
  window.digitaldata = {
    onclick: {
      linkName: 'flmc:ovf:prequal:result:content action',
      onclick: specialEvent
        ? 'home:ovf:prequal truck month:result:content:connect with a dealer'
        : 'home:ovf:prequal:result:content:connect with a dealer'
    }
  };
  window._satellite?.track('ford-credit-ovf-onclick');
}

export function tagDealerSubmissionConfirmationPage(specialEvent, countryCode, languageCode) {
  window.digitaldata = {
    page: {
      client: countryCode === 'USA' ? 'fmcc-usa' : 'fmcc-can',
      hierarchy: 'financing:ovf:prequal',
      pageName: specialEvent
        ? 'flmc:ovf:prequal truck month:app:6 result:connect with a dealer:success inquiry'
        : 'flmc:ovf:prequal:app:6 result:connect with a dealer:success inquiry',
      pageNameNoVehicle: specialEvent
        ? 'flmc:ovf:prequal truck month:app:6 result:connect with a dealer:success inquiry'
        : 'flmc:ovf:prequal:app:6 result:connect with a dealer:success inquiry',
      radUIVersion: getRadUIVersion(),
      site: window.location?.href?.split('?')[0],
      siteSection: 'ovf',
      userlanguage: languageCode === 'FR' ? 'fre': 'eng',
    }
  };
  window._satellite?.track('global-load');
}

export function showSurvey(customerEmail) {
  window.mdla = {
    showSurvey: true,
    email: customerEmail
  };
  if (window.KAMPYLE_ONSITE_SDK && typeof window.KAMPYLE_ONSITE_SDK.updatePageView === 'function') {
    window.KAMPYLE_ONSITE_SDK.updatePageView();
  }
}

export function tagVehicleSelectorExperienced({uuid}, variationKey, languageCode) {
  window.digitaldata = {
    page: {
      client: 'fmcc-usa',
      hierarchy: 'financing:ovf:prequal',
      pageName: 'flmc:ovf:prequal:app:1 personal',
      pageNameNoVehicle: 'flmc:ovf:prequal:app:1 personal',
      radUIVersion: getRadUIVersion(),
      site: window.location?.href?.split('?')[0],
      siteSection: 'ovf',
      userlanguage: languageCode === 'FR' ? 'fre': 'eng',
      optimizely: variationKey === 'vehicle_chooser_on' ? 'vehicle-selector:1' : 'vehicle-selector:0',
      customerID: uuid
    }
  };
  window._satellite?.track('optimizely-match');
}

export function tagVehicleSelectorOptions(optimizelyExperimentData, selectedVehicle) {
  window.digitaldata = {
    onclick: {
      linkName: 'flmc:ovf:prequal:content action',
      onclick: 'ovf:prequal:content:vehicle selector',
      optimizely: determineFlag(optimizelyExperimentData),
      toolDescriptor: `prequal:vehicle in mind:${selectedVehicle?.model.displayName && selectedVehicle?.year.value ? 'yes' : 'no'}`
    },
    vehicle:
      selectedVehicle?.model?.displayName && selectedVehicle?.year?.value
        ? {
            bodyModelTrim: selectedVehicle?.trim?.value,
            currentMake: selectedVehicle?.make.value,
            modelYear: selectedVehicle?.year?.value,
            nameplate: `${selectedVehicle?.make?.value} ${selectedVehicle?.model?.displayName}`
          }
        : null
  };
  window._satellite?.track('ford-credit-global-onclick');
}

export function tagGetPrequalifyButtonClick(optimizelyExperimentData, specialEvent) {
  window.digitaldata = {
    onclick: {
      linkName: 'flmc:ovf:prequal:content action',
      onclick: specialEvent ? 'ovf:prequal truck month:content:get prequalified' : 'ovf:prequal:content:get prequalified',
      optimizely: determineFlag(optimizelyExperimentData),
      tool: 'prequal:start'
    }
  };
  window._satellite?.track('ford-credit-global-onclick');
  window._satellite?.track('optimizely-match');
}

export function tagPrequalFormNextButtonClick(optimizelyExperimentData, specialEvent) {
  window.digitaldata = {
    onclick: {
      linkName: 'flmc:ovf:prequal:content action',
      onclick: specialEvent ? 'ovf:prequal truck month:content:application form' : 'ovf:prequal:content:application form',
      optimizely: determineFlag(optimizelyExperimentData)
    }
  };
  window._satellite?.track('ford-credit-global-onclick');
}
export function tagReviewFormSubmitButtonClick(optimizelyExperimentData, specialEvent) {
  window.digitaldata = {
    onclick: {
      linkName: 'flmc:ovf:prequal:content action',
      onclick: specialEvent ? 'ovf:prequal truck month:content:submit' : 'ovf:prequal:content:submit',
      tool: 'prequal:complete',
      optimizely: determineFlag(optimizelyExperimentData)
    }
  };
  window._satellite?.track('ford-credit-global-onclick');
}
